// @file Entrypoint for organization domain verification page
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useAuthOrgVerificationStore } from '@@/pinia/auth_org_verification_store'
import AuthOrgVerificationApp from '@@/vuecomponents/AuthOrgVerificationApp.vue'

void setupVueApp({
  el: '#auth_org_verification_app',
  rootComponent: AuthOrgVerificationApp,
  usePinia: true,
  initializePiniaStore() {
    useAuthOrgVerificationStore().initialize(ww.vueStartingState)
  },
})
